
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/groups/[groupId]/events/[eventId]/attendance",
      function () {
        return require("private-next-pages/community/groups/[groupId]/events/[eventId]/attendance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/groups/[groupId]/events/[eventId]/attendance"])
      });
    }
  